import { getPrice, Mode } from '~services/business/pricing';
import { theme } from '~globalStyles';
import { Trans } from '@lingui/macro';
import AmountFormat from '~components/i18n/amount-format';
import styled from 'styled-components';
import { PricingPlanComponentsProps } from '~components/pricing/types';

type YearlyInfoProps = {
    mode: Mode;
} & PricingPlanComponentsProps;

export const YearlyInfo = ({
    currency,
    language,
    mode,
    tier,
}: YearlyInfoProps) => {
    return (
        <YearlyPrice>
            (
            <AmountFormat
                noSign
                textColor="inherit"
                amount={getPrice(tier, mode, currency, true)}
                currencyEnum={currency}
                language={language}
            />{' '}
            <Lowercase>
                <Trans id="global.pricing.yearly" />
            </Lowercase>
            )
        </YearlyPrice>
    );
};

const YearlyPrice = styled.span`
    font-weight: 400;
    font-size: 15px;
    color: ${theme.lightGrey};
    margin-left: 8px;
    line-height: 10px;
`;

const Lowercase = styled.span`
    text-transform: lowercase;
`;
